import React from 'react';
import styled from 'styled-components';
import * as zero from '@zero/design-tokens/build/js/variables'
import { Spinner } from "react-bootstrap"


interface TextProps {
    color: string
}

export const Text = styled.span<TextProps>`
    font-family: ${zero.ZrFontFamilyDigitalRegular};
    color: ${(props) => props.color || '#000'};
`

export const Container = styled.div`    
    display: flex;
    flex-shrink: 1;
    align-items: center;
    justify-content: flex-start;

`

export const Loading = styled.div`
    background-image: url(//imguol.com/g/zero/0.8.0/loading.svg);
    
    background-position: 0;
    animation: spin 1.5s infinite linear;
`

export const StyledSpinner = styled(Spinner)`
    height: 10px;
    width: 10px;
    color: ${zero.ZrColorNeutralMedium02};
`

